import getLocal from '@/app/utils/getLocal';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';

export default function TheComp() {
    const { t } = useLang('rapid.StickyB');
    const { locale = 'us' } = getLocal();
    const [enter, setEnter] = useState(false);

    const IS_NA_SITE = ['us', 'ca'].includes(locale);
    const IS_EU_SITE = ['de', 'fr', 'es', 'it', 'eu', 'uk'].includes(locale);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${css.comp}`,
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    });

    return (
        <div className={css.comp}>
            <div className="sticky-box">
                <div className={`img-box ${enter ? 'enter' : ''}`}>
                    <EfImg
                        pc={
                            IS_EU_SITE || IS_NA_SITE
                                ? 'https://websiteoss.ecoflow.com/upload/image/1743132202909/rapid_na_F_pc.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729589385308/pc_part02.jpg'
                        }
                        h5={
                            IS_NA_SITE || IS_EU_SITE
                                ? 'https://websiteoss.ecoflow.com/upload/image/1743132202752/rapid_na_F_m.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729589385143/m_part02.jpg'
                        }
                    />
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <p className="label">{t('label')}</p>
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
